/**************************************************
 * Nombre:       Registro
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useFormulario} from "../Modulo_formularios/Hooks/useFormulario";
import {CheckBoxOutlined, Google, Mail} from '@mui/icons-material'
import {theme} from "../Tema";
import {ingresarConGoogle} from "../Servicios/Auth/Funciones/ingresarConGoogle";
import {useDialogo} from "../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Soporte_Externo from "../Dashboard/Dialogos/Dialogo_Soporte_Externo";
import Formulario_ingreso from "./Formularios/Formulario_ingreso";
import {funIngresarCorreoPass} from "../Servicios/Auth/funIngresarCorreoPass";
import {funRecuperarContrasena} from "../Servicios/Auth/funRecuperarContrasena";
import {useCargador} from "../Modulo_Cargador/Hooks/useCargador";
import logo from "../Recursos/logo_redondo.svg";


const Ingreso = ({setEsRegistro}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: {}})
    const {Cargador, Avisos, nuevoAviso, terminar, iniciarCarga} = useCargador({logoRedondo: logo})
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Soporte_Externo, titulo: 'Ticket de soporte'})

    const entrar = async () => {
        await ingresarConGoogle()
    }

    const ingresar = async () => {
        const entidad = await obtenerEntidad()
        iniciarCarga('Ingresando')
        await funIngresarCorreoPass(entidad.correo, entidad.pass)
        terminar({aviso: 'Ingreso exitoso'})
    }


    const recuperar = async () => {
        const entidad = await obtenerEntidad()
        await funRecuperarContrasena(entidad.correo)
    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Cargador/>

            <Avisos/>

            <Dialogo/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 24, fontWeight: 800}}>Ingreso</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography sx={{fontSize: 16, fontWeight: 300, lineHeight: 1.1}}>Si ya haz creado tu cuenta ingresa con
                    con correo</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                <Formulario_ingreso props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 3, mb: 2}}>
                <Button startIcon={<Mail/>}
                        onClick={() => ingresar()}
                        sx={{pt: 1.5, pb: 1.5, mx: 1, px: 4}}
                >Ingresar</Button>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end'}}>
                <Typography
                    onClick={() => recuperar()}
                    sx={{cursor: 'pointer'}}
                >Recuperar Contraseña</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                <Typography sx={{fontSize: 16, fontWeight: 300, lineHeight: 1.1}}>o si ya tienes una cuenta con
                    Google</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3, mb: 2}}>
                <Button fullWidth startIcon={<Google/>}
                        onClick={() => entrar()}
                        sx={{pt: 1.5, pb: 1.5, mx: 1}}
                >Ingresar mediante
                    Google</Button>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                <Typography sx={{fontSize: 16, fontWeight: 300, lineHeight: 1.1, textAlign: 'center'}}>¿Aun no tienes
                    cuenta? <br/> <span
                        style={{color: theme.palette.primary.main, fontWeight: 600}}>Registrate ahora!</span>
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3, mb: 2}}>
                <Button fullWidth startIcon={<CheckBoxOutlined/>}
                        variant={'outlined'}
                        onClick={() => setEsRegistro(true)}
                        sx={{pt: 1.5, pb: 1.5, mx: 1}}
                >Registrarme
                </Button>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                <Typography sx={{fontSize: 14, fontWeight: 300, lineHeight: 1.1, textAlign: 'center'}}>¿Tienes problemas
                    para ingresar? <br/> contacta con soporte</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2, mb: 0}}>
                <Button
                    onClick={() => abrir()}
                    variant={'text'} sx={{fontWeight: 400}}>Crear un ticket de soporte</Button>
            </Grid>


        </Grid>
    )

}
export default Ingreso